import "./HighlightBlock.css";

export default function HighlightBlock({
    text,
    color = "var(--color-orange)",
    barHeight = "100px",
    italic = true,
    as = "p",
    style = {}
}) {
    const Tag = as;
    return (
        <div
            className="line-text-wrapper"
            style={{
                "--line-color": color,
            }}
        >
            <span className="line-text-bar" aria-hidden="true" style={{height: barHeight}} />
            <Tag className={`line-text-content${italic ? " line-text-italic" : ""}`} style={style}>
                {text}
            </Tag>
        </div>
    );
}